/* eslint-disable max-len */
import React from 'react';
import {
  FaThumbsDown, FaThumbsUp,
} from 'react-icons/fa';
import Button from './Button';
import ApplyNowHeader from './ApplyNowHeader';

export default function NewAssesmentComplete({
  handleSubmitFeedback,
  jobTitle,
  evaluation,
  resumeName,
  candidateName,
}: {
  resumeName: string;
  jobTitle: string;
  evaluation: string;
  candidateName: string | null;
  handleSubmitFeedback: (rating: 'positive' | 'negative') => void;
}): JSX.Element {
  return (
    <div className="mx-auto w-full max-w-[660px]">
      <ApplyNowHeader resumeName={resumeName} candidateName={candidateName} />
      <section className="space-y-6">
        <h2 className="mb-2 font-semibold text-lg">
          Job Profile -
          {' '}
          {jobTitle}
        </h2>
        <div className="flex flex-col gap-4 border-[#d9d9db] mt-0 p-4 border border-solid rounded-lg">
          <div className="flex justify-start items-center">
            <img
              src="/CheckCircle.svg"
              alt="Assesment Completed"
              width="64"
              height="64"
            />
            <span className="ml-4 font-semibold text-[#00349A] text-3xl">Assesment Complete</span>
          </div>
          <div className="bg-[#E9F0FD] p-4 rounded w-full h-full">
            <div className="font-normal text-xl">
              <p className="mt-0 pt-0">AI Generated Feedback:</p>
              <p className="text-secondary">
                {evaluation}
              </p>
              <p className="text-secondary">Kindly rate your experience</p>
            </div>
            <div className="flex justify-center items-center gap-4 bg-white p-2 rounded w-full">
              <Button variant="outlined" className="bg-[#E9F0FD80]/50 border-none ring-0 w-full outline-none" onClick={() => handleSubmitFeedback('positive')}>
                <FaThumbsUp className="w-7 h-7" color="#2065EC" />
              </Button>
              <Button variant="outlined" className="bg-[#E9F0FD80]/50 border-none ring-0 w-full outline-none" onClick={() => handleSubmitFeedback('negative')}>
                <FaThumbsDown className="w-7 h-7" color="#2065EC" />
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
